export const CONSUME_LIST = 'user/consumeList';